import _ from '../utils'

const PAGE_TRANSITION_CONFIG = {
    transition: _.select( '.c-page__transition' )
}

export default PAGE_TRANSITION_CONFIG